import { setClientArchived } from '../../services/clients';
import { confirmAsk, notify } from '../../store/feedback';

/* Archivage d'un projet (page Projets, arbitrage du 06/10/2026) : range la carte dans l'onglet
   Archivés sans toucher au statut CRM du client ni à son C.A. */
export default function projectArchiveHandlers({ update }) {
  async function setProjectArchived(client, archive) {
    if (
      archive &&
      !(await confirmAsk(`Archiver « ${client.nom} » ? Il passera dans l'onglet Archivés.`, {
        title: 'Archivage',
        confirmLabel: 'Archiver',
      }))
    )
      return;
    const clientId = client.id;
    const { error } = await setClientArchived(clientId, archive);
    if (error)
      return void notify((archive ? "Erreur lors de l'archivage : " : 'Erreur : ') + error.message);
    update((s) => ({
      ...s,
      clients: s.clients.map((c) =>
        c.id === clientId ? { ...c, archivedAt: archive ? new Date().toISOString() : null } : c,
      ),
    }));
  }

  return { setProjectArchived };
}
